import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-ice-cream",
  "use": "icon-si-glyph-ice-cream-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-ice-cream\" id=\"icon-si-glyph-ice-cream\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1090</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(5.000000, 1.000000)\" fill=\"#434343\">\n            <path d=\"M4.513,15.906 L7,7.042 L2,7.042 L4.513,15.906\" class=\"si-glyph-fill\" />\n            <path d=\"M6.775,1.732 C6.459,0.725 5.617,0 4.617,0 C3.527,0 2.621,0.856 2.384,2.002 C2.363,2.002 2.343,1.994 2.321,1.994 C1.051,1.994 0.023,3.153 0.023,4.583 C0.023,5.844 0.717,6.891 1.777,7.121 L7.306,7.245 C8.248,6.87 9,5.63 9,4.44 C9,3.008 8.02,1.848 6.775,1.732 L6.775,1.732 Z\" class=\"si-glyph-fill\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-ice-cream.svg
// module id = 51g1
// module chunks = 62